import { Filter, FilterSet, FilterConfig, FilterSetService } from './../../../services/filter-set.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	selector: 'bb-horizontal-filterset',
	templateUrl: './bb-horizontal-filterset.component.html',
	styleUrls: ['./bb-horizontal-filterset.component.scss']
})

export class BbHorizontalFiltersetComponent implements OnInit, OnDestroy {

	@Input() activeFilters: any[];
	@Input() filterSet: FilterSet;
	@Input() filterConfig: FilterConfig[] = [];

	private filterSetChangedSubscription: Subscription;

	constructor(private filterSetService: FilterSetService) { }

	ngOnInit() {
		this.filterSet = this.filterSetService.getFilterSet();

		this.filterSetChangedSubscription = this.filterSetService.filterSetChangedObservable.subscribe(filterSet => {
			this.filterSet = filterSet;
		});
	}

	filterRemoved(filter: Filter) {
		this.filterSetService.removeFilter(filter);
	}

	ngOnDestroy() {
		this.filterSetChangedSubscription.unsubscribe();
	}
}
